<template>
  <section v-if="newBizParam">
    <!-- 规则1 start-->
    <div
      class="rule"
      style="
        border-bottom: 1px solid #d9d9d9;
        padding-bottom: 16px;
        margin-bottom: 16px;
      "
    >
      <h5>选择联系人限制：</h5>
      <el-checkbox
        @change="
          changeCheck(0);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.selectItemNum.enabled"
      ></el-checkbox>
      <span class="txt">规则1：拜访记录单次选择</span>
      <div
        :class="
          !newBizParam.selectItemNum.ruleItemList.length &&
          newBizParam.selectItemNum.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-select
          @change="$emit('changeData', newBizParam)"
          class="w260"
          :disabled="!newBizParam.selectItemNum.enabled"
          v-model="newBizParam.selectItemNum.ruleItemList"
          multiple
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, index) in optionSCDY1"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span class="txt">各不超过</span>
      <div
        :class="
          !newBizParam.selectItemNum.limitMax &&
          newBizParam.selectItemNum.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-input
          :disabled="!newBizParam.selectItemNum.enabled"
          class="rule-input-box"
          v-model="newBizParam.selectItemNum.limitMax"
          @input="
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          type="text"
          :min="1"
          :maxlength="7"
        ></el-input>
      </div>

      <span class="txt">人</span>
      <p
        class="tips"
        v-if="
          (!newBizParam.selectItemNum.ruleItemList.length ||
            !newBizParam.selectItemNum.limitMax) &&
          newBizParam.selectItemNum.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <!-- 规则1 end-->
    <div class="rule-wrap">
      <h5 style="margin-top: 10px">拜访联系人限制：</h5>
      <el-tabs v-model="ruleModel1">
        <el-tab-pane label="按天/按月" name="first">
          <!-- 规则2 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(1);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.dayItemBelongSameCustomer.enabled"
            ></el-checkbox>
            <span class="txt">规则2：限制</span>
            <div
              :class="
                !newBizParam.dayItemBelongSameCustomer.isSamePerson &&
                newBizParam.dayItemBelongSameCustomer.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.dayItemBelongSameCustomer.enabled"
                class="w130"
                v-model="newBizParam.dayItemBelongSameCustomer.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt"
              ><i class="theme-color">同一天</i>拜访<i class="theme-color"
                >同一家企业客户</i
              >联系人的频次</span
            >
            <p
              class="tips"
              v-if="
                !newBizParam.dayItemBelongSameCustomer.isSamePerson &&
                newBizParam.dayItemBelongSameCustomer.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div
            class="rule-child"
            v-if="newBizParam.dayItemBelongSameCustomer.enabled"
          >
            <div
              class="rule"
              v-for="(item, index) in newBizParam.dayItemBelongSameCustomer
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sameLimitMax = null;
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >人次，同一人不可超过<span
                  :class="
                    !item.sameLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sameLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <p
                class="tips"
                v-if="
                  (!item.sameLimitMax || !item.sumLimitMax) &&
                  item.enabled &&
                  isOpenCheck
                "
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则2 end-->

          <!-- 规则3 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(2);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.dayItemSum.enabled"
            ></el-checkbox>
            <span class="txt">规则3：限制</span>
            <div
              :class="
                !newBizParam.dayItemSum.isSamePerson &&
                newBizParam.dayItemSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.dayItemSum.enabled"
                class="w130"
                v-model="newBizParam.dayItemSum.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt"
              ><i class="theme-color">同一天</i>拜访<i class="theme-color"
                >联系人</i
              >的频次</span
            >
            <p
              class="tips"
              v-if="
                !newBizParam.dayItemSum.isSamePerson &&
                newBizParam.dayItemSum.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div class="rule-child" v-if="newBizParam.dayItemSum.enabled">
            <div
              class="rule"
              v-for="(item, index) in newBizParam.dayItemSum.ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >人次</span
              >
              <p
                class="tips"
                v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则3 end-->

          <!-- 规则4 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(4);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.monthItemSameSum.enabled"
            ></el-checkbox>
            <span class="txt">规则4：限制</span>
            <div
              :class="
                !newBizParam.monthItemSameSum.isSamePerson &&
                newBizParam.monthItemSameSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.monthItemSameSum.enabled"
                class="w130"
                v-model="newBizParam.monthItemSameSum.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt"
              ><i class="theme-color">同一月</i>拜访<i class="theme-color"
                >同一位联系人</i
              >的频次</span
            >
            <p
              class="tips"
              v-if="
                !newBizParam.monthItemSameSum.isSamePerson &&
                newBizParam.monthItemSameSum.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div class="rule-child" v-if="newBizParam.monthItemSameSum.enabled">
            <div
              class="rule"
              v-for="(item, index) in newBizParam.monthItemSameSum.ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >人次</span
              >
              <p
                class="tips"
                v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则4 end-->
        </el-tab-pane>
        <el-tab-pane label="自定义" name="second">
          <!-- 规则9 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(9);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.diyDayItemBelongSameCustomer.enabled"
            ></el-checkbox>
            <span class="txt">规则9：限制</span>
            <div
              :class="
                !newBizParam.diyDayItemBelongSameCustomer.isSamePerson &&
                newBizParam.diyDayItemBelongSameCustomer.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.diyDayItemBelongSameCustomer.enabled"
                class="w130"
                v-model="newBizParam.diyDayItemBelongSameCustomer.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt">同核算月内每</span>
            <div
              :class="
                !newBizParam.diyDayItemBelongSameCustomer.dayLimitMax &&
                newBizParam.diyDayItemBelongSameCustomer.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-input
                class="rule-input-box"
                v-model="newBizParam.diyDayItemBelongSameCustomer.dayLimitMax"
                @input="
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                @blur="dayLimitMaxBlur('diyDayItemBelongSameCustomer')"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                type="text"
                :min="1"
                :maxlength="7"
                :disabled="!newBizParam.diyDayItemBelongSameCustomer.enabled"
              ></el-input>
            </div>
            <span class="txt"
              >天拜访<i class="theme-color">同一家企业客户</i>联系人的频次
              <el-tooltip effect="light" placement="top-start">
                <i class="el-icon-question"></i>
                <p slot="content">
                  举例：同一个业务员拜访同一个药店每两周不得超过2次这个规则的含义是：
                  <br />
                  1、从某个核算月的第一天开始，顺着往后推每14天不能超过2次，最后一周如果不满14天，
                  <br />
                  &nbsp;&nbsp;那么按照从最后一周的第一天到当前核算月最后一天这个时间范围判断是否超出限制，如果超出也拦截。
                  <br />
                  2、案例1：2025年6月，某企业是自然月核算，那么6/1-6/14、6/15-6/28、6/29-6/30
                  同一个周期内不能超过2次。
                  <br />
                  3、案例2：2025年6月，某企业是5月25-6月26日核算，那么5/25-6/7、6/8-6/21、6/22-6/30
                  同一个周期内不能超过2次
                </p>
              </el-tooltip>
            </span>
            <p
              class="tips"
              v-if="
                (!newBizParam.diyDayItemBelongSameCustomer.isSamePerson ||
                  !newBizParam.diyDayItemBelongSameCustomer.dayLimitMax) &&
                newBizParam.diyDayItemBelongSameCustomer.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div
            class="rule-child"
            v-if="newBizParam.diyDayItemBelongSameCustomer.enabled"
          >
            <div
              class="rule"
              v-for="(item, index) in newBizParam.diyDayItemBelongSameCustomer
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sameLimitMax = null;
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >人次，同一人不可超过<span
                  :class="
                    !item.sameLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sameLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <p
                class="tips"
                v-if="
                  (!item.sameLimitMax || !item.sumLimitMax) &&
                  item.enabled &&
                  isOpenCheck
                "
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则9 end-->

          <!-- 规则10 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(10);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.diyDayItemSum.enabled"
            ></el-checkbox>
            <span class="txt">规则10：限制</span>
            <div
              :class="
                !newBizParam.diyDayItemSum.isSamePerson &&
                newBizParam.diyDayItemSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.diyDayItemSum.enabled"
                class="w130"
                v-model="newBizParam.diyDayItemSum.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt">同核算月内每</span>
            <div
              :class="
                !newBizParam.diyDayItemSum.dayLimitMax &&
                newBizParam.diyDayItemSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-input
                class="rule-input-box"
                v-model="newBizParam.diyDayItemSum.dayLimitMax"
                @input="
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                @blur="dayLimitMaxBlur('diyDayItemSum')"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                type="text"
                :min="1"
                :maxlength="7"
                :disabled="!newBizParam.diyDayItemSum.enabled"
              ></el-input>
            </div>
            <span class="txt"
              >天拜访<i class="theme-color">联系人</i>的频次
              <el-tooltip effect="light" placement="top-start">
                <i class="el-icon-question"></i>
                <p slot="content">
                  举例：同一个业务员拜访同一个药店每两周不得超过2次这个规则的含义是：
                  <br />
                  1、从某个核算月的第一天开始，顺着往后推每14天不能超过2次，最后一周如果不满14天，
                  <br />
                  &nbsp;&nbsp;那么按照从最后一周的第一天到当前核算月最后一天这个时间范围判断是否超出限制，如果超出也拦截。
                  <br />
                  2、案例1：2025年6月，某企业是自然月核算，那么6/1-6/14、6/15-6/28、6/29-6/30
                  同一个周期内不能超过2次。
                  <br />
                  3、案例2：2025年6月，某企业是5月25-6月26日核算，那么5/25-6/7、6/8-6/21、6/22-6/30
                  同一个周期内不能超过2次
                </p>
              </el-tooltip>
            </span>
            <p
              class="tips"
              v-if="
                (!newBizParam.diyDayItemSum.isSamePerson ||
                  !newBizParam.diyDayItemSum.dayLimitMax) &&
                newBizParam.diyDayItemSum.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div class="rule-child" v-if="newBizParam.diyDayItemSum.enabled">
            <div
              class="rule"
              v-for="(item, index) in newBizParam.diyDayItemSum.ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >人次</span
              >
              <p
                class="tips"
                v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则10 end-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="rule-wrap">
      <h5 style="margin-top: 10px">拜访企业客户限制：</h5>
      <el-tabs v-model="ruleModel2">
        <el-tab-pane label="按天/按月" name="first">
          <!-- 规则5 start -->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(5);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.dayCustomerSumAndSame.enabled"
            ></el-checkbox>
            <span class="txt">规则5：限制</span>
            <div
              :class="
                !newBizParam.dayCustomerSumAndSame.isSamePerson &&
                newBizParam.dayCustomerSumAndSame.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.dayCustomerSumAndSame.enabled"
                class="w130"
                v-model="newBizParam.dayCustomerSumAndSame.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt"
              ><i class="theme-color">同一天</i>拜访<i class="theme-color"
                >企业客户</i
              >的频次</span
            >
            <p
              class="tips"
              v-if="
                !newBizParam.dayCustomerSumAndSame.isSamePerson &&
                newBizParam.dayCustomerSumAndSame.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div
            class="rule-child"
            v-if="newBizParam.dayCustomerSumAndSame.enabled"
          >
            <div
              class="rule"
              v-for="(item, index) in newBizParam.dayCustomerSumAndSame
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sameLimitMax = null;
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] ?? "其他" }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input>
                </span>
                <span v-if="item.customerType !== '99'"
                  >次，同一家不可超过</span
                >
                <span
                  v-if="item.customerType !== '99'"
                  :class="
                    !item.sameLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sameLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <div class="rule" v-if="item.customerType == '99'">
                <el-tooltip effect="light" placement="top-start">
                  <div slot="content">
                    该条规则可以和规则5-不同客户类型组合使用或者单独使用，举例设置：
                    <br />
                    1）药店：总拜访次数 <= 10 且 同一家药店 <=1次 <br />
                    2）商业公司：总拜访次数 <= 4 且 同一家商业公司 <=1次
                    <br />
                    3）医院：总拜访次数 <= 4 且 同一家医院 <=1次 <br />
                    4）其他：总拜访次数 <= 4 且 同一家其他类型客户 <=1
                    <br />
                    5）所有类型累计：总拜访次数 <= 10
                  </div>
                  <i class="el-icon-question" style="color: #606266"></i>
                </el-tooltip>
              </div>

              <p class="tips" v-if="getRuleFiveTips(item)">请将规则填写完整</p>
            </div>
          </div>
          <!-- 规则5 end-->

          <!-- 规则6 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(6);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.dayCustomerSameSum.enabled"
            ></el-checkbox>
            <span class="txt">规则6：限制</span>
            <div
              :class="
                !newBizParam.dayCustomerSameSum.isSamePerson &&
                newBizParam.dayCustomerSameSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.dayCustomerSameSum.enabled"
                class="w130"
                v-model="newBizParam.dayCustomerSameSum.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt"
              ><i class="theme-color">同一天</i>拜访<i class="theme-color"
                >同一家企业客户</i
              >的频次</span
            >
            <p
              class="tips"
              v-if="
                !newBizParam.dayCustomerSameSum.isSamePerson &&
                newBizParam.dayCustomerSameSum.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div class="rule-child" v-if="newBizParam.dayCustomerSameSum.enabled">
            <div
              class="rule"
              v-for="(item, index) in newBizParam.dayCustomerSameSum
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <p
                class="tips"
                v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则6 end-->

          <!-- 规则7 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(7);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.monthCustomerSameSum.enabled"
            ></el-checkbox>
            <span class="txt">规则7：限制</span>
            <div
              :class="
                !newBizParam.monthCustomerSameSum.isSamePerson &&
                newBizParam.monthCustomerSameSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="isSamePersonChange"
                :disabled="!newBizParam.monthCustomerSameSum.enabled"
                class="w130"
                v-model="newBizParam.monthCustomerSameSum.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt"
              ><i class="theme-color">同一月</i>拜访<i class="theme-color"
                >同一家企业客户</i
              >的频次</span
            >
            <p
              class="tips"
              v-if="
                !newBizParam.monthCustomerSameSum.isSamePerson &&
                newBizParam.monthCustomerSameSum.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div
            class="rule-child"
            v-if="newBizParam.monthCustomerSameSum.enabled"
          >
            <div
              class="rule"
              v-for="(item, index) in newBizParam.monthCustomerSameSum
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.isSamePersonExecute = null;
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <template
                v-if="newBizParam.monthCustomerSameSum.isSamePerson == 'N'"
              >
                <el-checkbox
                  v-model="item.isSamePersonExecute"
                  :disabled="
                    !item.enabled ||
                    newBizParam.monthCustomerSameSum.isSamePerson == 'Y'
                  "
                ></el-checkbox>
                <span class="txt">必须同一人执行</span>
              </template>
              <p
                class="tips"
                v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则7 end-->
        </el-tab-pane>
        <el-tab-pane label="自定义" name="second">
          <!-- 规则11 start -->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(11);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.diyDayCustomerSumAndSame.enabled"
            ></el-checkbox>
            <span class="txt">规则11：限制</span>
            <div
              :class="
                !newBizParam.diyDayCustomerSumAndSame.isSamePerson &&
                newBizParam.diyDayCustomerSumAndSame.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.diyDayCustomerSumAndSame.enabled"
                class="w130"
                v-model="newBizParam.diyDayCustomerSumAndSame.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt">同核算月内每</span>
            <div
              :class="
                !newBizParam.diyDayCustomerSumAndSame.dayLimitMax &&
                newBizParam.diyDayCustomerSumAndSame.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-input
                class="rule-input-box"
                v-model="newBizParam.diyDayCustomerSumAndSame.dayLimitMax"
                @input="
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                @blur="dayLimitMaxBlur('diyDayCustomerSumAndSame')"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                type="text"
                :min="2"
                :maxlength="7"
                :disabled="!newBizParam.diyDayCustomerSumAndSame.enabled"
              ></el-input>
            </div>
            <span class="txt"
              >天拜访<i class="theme-color">企业客户</i>的频次
              <el-tooltip effect="light" placement="top-start">
                <i class="el-icon-question"></i>
                <p slot="content">
                  举例：同一个业务员拜访同一个药店每两周不得超过2次这个规则的含义是：
                  <br />
                  1、从某个核算月的第一天开始，顺着往后推每14天不能超过2次，最后一周如果不满14天，
                  <br />
                  &nbsp;&nbsp;那么按照从最后一周的第一天到当前核算月最后一天这个时间范围判断是否超出限制，如果超出也拦截。
                  <br />
                  2、案例1：2025年6月，某企业是自然月核算，那么6/1-6/14、6/15-6/28、6/29-6/30
                  同一个周期内不能超过2次。
                  <br />
                  3、案例2：2025年6月，某企业是5月25-6月26日核算，那么5/25-6/7、6/8-6/21、6/22-6/30
                  同一个周期内不能超过2次
                </p>
              </el-tooltip>
            </span>
            <p
              class="tips"
              v-if="
                (!newBizParam.diyDayCustomerSumAndSame.isSamePerson ||
                  !newBizParam.diyDayCustomerSumAndSame.dayLimitMax) &&
                newBizParam.diyDayCustomerSumAndSame.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div
            class="rule-child"
            v-if="newBizParam.diyDayCustomerSumAndSame.enabled"
          >
            <div
              class="rule"
              v-for="(item, index) in newBizParam.diyDayCustomerSumAndSame
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sameLimitMax = null;
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次，同一家不可超过<span
                  :class="
                    !item.sameLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    class="rule-input-box"
                    v-model="item.sameLimitMax"
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <p
                class="tips"
                v-if="
                  (!item.sameLimitMax || !item.sumLimitMax) &&
                  item.enabled &&
                  isOpenCheck
                "
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则11 end-->

          <!-- 规则12 start-->
          <div class="rule">
            <el-checkbox
              @change="
                changeCheck(12);
                $emit('changeData', newBizParam);
              "
              v-model="newBizParam.diyDayCustomerSameSum.enabled"
            ></el-checkbox>
            <span class="txt">规则12：限制</span>
            <div
              :class="
                !newBizParam.diyDayCustomerSameSum.isSamePerson &&
                newBizParam.diyDayCustomerSameSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-select
                @change="$emit('changeData', newBizParam)"
                :disabled="!newBizParam.diyDayCustomerSameSum.enabled"
                class="w130"
                v-model="newBizParam.diyDayCustomerSameSum.isSamePerson"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in isSamePersonOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <span class="txt">同核算月内每</span>
            <div
              :class="
                !newBizParam.diyDayCustomerSameSum.dayLimitMax &&
                newBizParam.diyDayCustomerSameSum.enabled &&
                isOpenCheck
                  ? 'red-border'
                  : ''
              "
            >
              <el-input
                class="rule-input-box"
                v-model="newBizParam.diyDayCustomerSameSum.dayLimitMax"
                @input="
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                @blur="dayLimitMaxBlur('diyDayCustomerSameSum')"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                type="text"
                :min="2"
                :maxlength="7"
                :disabled="!newBizParam.diyDayCustomerSameSum.enabled"
              ></el-input>
            </div>
            <span class="txt"
              >天拜访<i class="theme-color">同一家企业客户</i>的频次
              <el-tooltip effect="light" placement="top-start">
                <i class="el-icon-question"></i>
                <p slot="content">
                  举例：同一个业务员拜访同一个药店每两周不得超过2次这个规则的含义是：
                  <br />
                  1、从某个核算月的第一天开始，顺着往后推每14天不能超过2次，最后一周如果不满14天，
                  <br />
                  &nbsp;&nbsp;那么按照从最后一周的第一天到当前核算月最后一天这个时间范围判断是否超出限制，如果超出也拦截。
                  <br />
                  2、案例1：2025年6月，某企业是自然月核算，那么6/1-6/14、6/15-6/28、6/29-6/30
                  同一个周期内不能超过2次。
                  <br />
                  3、案例2：2025年6月，某企业是5月25-6月26日核算，那么5/25-6/7、6/8-6/21、6/22-6/30
                  同一个周期内不能超过2次
                </p>
              </el-tooltip>
            </span>
            <p
              class="tips"
              v-if="
                (!newBizParam.diyDayCustomerSameSum.isSamePerson ||
                  !newBizParam.diyDayCustomerSameSum.dayLimitMax) &&
                newBizParam.diyDayCustomerSameSum.enabled &&
                isOpenCheck
              "
            >
              请将规则填写完整
            </p>
          </div>
          <div
            class="rule-child"
            v-if="newBizParam.diyDayCustomerSameSum.enabled"
          >
            <div
              class="rule"
              v-for="(item, index) in newBizParam.diyDayCustomerSameSum
                .ruleItemList"
              :key="index"
            >
              <el-checkbox
                @change="
                  item.sumLimitMax = null;
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                v-model="item.enabled"
              ></el-checkbox>
              <span class="txt"
                ><i class="theme-color">
                  {{ CUSTOMERTYPEMAP[item.customerType] }} </i
                >不可超过<span
                  :class="
                    !item.sumLimitMax && item.enabled && isOpenCheck
                      ? 'red-border txt'
                      : 'txt'
                  "
                  ><el-input
                    @input="
                      $forceUpdate();
                      $emit('changeData', newBizParam);
                    "
                    class="rule-input-box"
                    v-model="item.sumLimitMax"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="7"
                    :disabled="!item.enabled"
                  ></el-input></span
                >次</span
              >
              <p
                class="tips"
                v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
              >
                请将规则填写完整
              </p>
            </div>
          </div>
          <!-- 规则6 end-->
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 规则8 start-->
    <div
      class="rule"
      style="border-top: 1px solid #d9d9d9; padding-top: 16px; margin-top: 16px"
    >
      <h5>数据重复性拦截：</h5>
      <el-checkbox
        @change="$emit('changeData', newBizParam)"
        v-model="newBizParam.customerRepeatIntercept"
      ></el-checkbox>
      <span class="txt"
        >规则8：同企业所有人同一天内，提交同企业客户<i class="theme-color"
          >同产品名称的数据</i
        >不可重复</span
      >
      <el-tooltip class="item" effect="light" placement="top-start">
        <div slot="content">
          同企业所有人中，提交同一天同企业客户（药店/商业公司/医院/其他）、<i
            class="tips-color"
            >同产品名称（哪怕不同规格不同厂家）的数据</i
          >进行拦截提示"该客户当日已拜访，不可重复提交"。
        </div>
        <i class="el-icon-question" style="color: #606266"></i>
      </el-tooltip>
    </div>
    <!-- 规则8 end-->

    <!-- 规则 13 start-->
    <div
      class="rule"
      style="border-top: 1px solid #d9d9d9; padding-top: 16px; margin-top: 16px"
    >
      <h5>拜访间隔时间规则：</h5>
      <el-checkbox
        @change="
          changeCheck(13);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.checkIntervalTime.enabled"
      ></el-checkbox>
      <span class="txt">规则13：两家终端拜访间隔需至少</span>
      <div
        :class="
          newBizParam.checkIntervalTime.enabled &&
          !newBizParam.checkIntervalTime.intervalTime &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-select
          @change="$emit('changeData', newBizParam)"
          class="w130"
          :disabled="!newBizParam.checkIntervalTime.enabled"
          v-model="newBizParam.checkIntervalTime.intervalTime"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in getCodeListByKey('时长')"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-tooltip class="item" effect="light" placement="top-start">
        <div slot="content">
          校验每个业务员录入拜访进店和拜访时长的规则如下：
          <br />
          A、例如若配置两家终端拜访间隔要在30min：
          <br />
          1）如果第一家进店时间9：00，所选的拜访时长30分钟内，那么第二家进店时间可以是9：30以后；
          <br />
          2）如果第一家进店时间9：00，拜访时长30分钟以上（例如拜访时长45分钟），那么第二家进店时间可以是9：45以后。
          <br />
          B、例如若配置两家终端拜访间隔要在25min以上：
          <br />
          1）如果第一家进店时间9：00，拜访时长25分钟内，那么第二家进店时间可以是9：25以后；
          <br />
          2）如果第一家进店时间9：00，拜访时长25分钟以上（例如拜访时长45分钟），那么第二家进店时间可以是9：45以后。
          <br />
          C、如果未配置进店时长，那么第二家进店时间都按当前录入的进店时间排序后，前后相邻客户的进店时间+配置的间隔时间校验。
          <br />
        </div>
        <i class="el-icon-question txt" style="color: #606266"></i>
      </el-tooltip>
      <p
        class="tips"
        v-if="
          newBizParam.checkIntervalTime.enabled &&
          !newBizParam.checkIntervalTime.intervalTime &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <!-- 规则 13 end-->
  </section>
</template>

<script>
import { CUSTOMERTYPEMAP, CustomerTypeEnum } from "./enum.js";
export default {
  props: ["bizParam1",'fieldList'],
  data() {
    return {
      CUSTOMERTYPEMAP,
      CustomerTypeEnum,
      ruleModel1: "first",
      ruleModel2: "first",
      isOpenCheck: false,
      optionSCDY1: [
        {
          value: "3",
          label: "医生",
        },
        {
          value: "10",
          label: "商业客户",
        },
        {
          value: "11",
          label: "居间人",
        },
        {
          value: "15",
          label: "药店联系人",
        },
      ],
      isSamePersonOption: [
        {
          value: "Y",
          label: "同一人员",
        },
        {
          value: "N",
          label: "不同人员",
        },
      ],
      newBizParam: null,
    };
  },
  watch: {
    bizParam1: {
      deep: true,
      handler(newBizParam) {
        if (!this.$route.query.guid && this.$route.query.type != 3) return;
        this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
        this.$forceUpdate();
      },
    },
  },
  created() {
    if (this.$route.query.guid || this.$route.query.type == 3) return;
    this.newBizParam = this.bizParam1;
  },
  mounted() {
    // this.$nextTick((_) => {
    //     const activeBarElement = document.getElementsByClassName(
    //         "el-tabs__active-bar"
    //     )
    //     console.log(activeBarElement)
    //     activeBarElement[0].style.width = "73px";
    //     activeBarElement[1].style.width = "73px";
    // })
  },
  methods: {
    getRuleFiveTips(item) {
      if (item.customerType == "99") {
        return !item.sumLimitMax && item.enabled && this.isOpenCheck;
      }
      return (
        (!item.sameLimitMax || !item.sumLimitMax) &&
        item.enabled &&
        this.isOpenCheck
      );
    },
    isSamePersonChange() {
      this.newBizParam.monthCustomerSameSum.ruleItemList.forEach((item) => {
        item.isSamePersonExecute = null;
      });
      this.$emit("changeData", this.newBizParam);
      this.$forceUpdate();
    },
    dayLimitMaxBlur(param) {
      if (this.newBizParam[param].dayLimitMax == 1) {
        this.newBizParam[param].dayLimitMax = null;
      }
    },
    changeCheck(i) {
      // 规则1
      if (!this.newBizParam.selectItemNum.enabled && i == 0) {
        this.newBizParam.selectItemNum = {
          enabled: false,
          limitMax: null,
          ruleItemList: [],
        };
      }
      // 规则2
      if (!this.newBizParam.dayItemBelongSameCustomer.enabled && i == 1) {
        this.newBizParam.dayItemBelongSameCustomer = {
          enabled: false,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "3",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "10",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            // {
            //     "enabled": false,
            //     "customerType": "11",
            //     "sameLimitMax": null,
            //     "sumLimitMax": null
            // },
            {
              enabled: false,
              customerType: "15",
              sameLimitMax: null,
              sumLimitMax: null,
            },
          ],
        };
      }
      // 规则9
      if (!this.newBizParam.diyDayItemBelongSameCustomer.enabled && i == 9) {
        this.newBizParam.diyDayItemBelongSameCustomer = {
          enabled: false,
          dayLimitMax: null,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "3",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "10",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            // {
            //     "enabled": false,
            //     "customerType": "11",
            //     "sameLimitMax": null,
            //     "sumLimitMax": null
            // },
            {
              enabled: false,
              customerType: "15",
              sameLimitMax: null,
              sumLimitMax: null,
            },
          ],
        };
      }
      // 规则3
      if (!this.newBizParam.dayItemSum.enabled && i == 2) {
        this.newBizParam.dayItemSum = {
          enabled: false,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "3",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "10",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "11",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "15",
              sumLimitMax: null,
            },
          ],
        };
      }
      // 规则10
      if (!this.newBizParam.diyDayItemSum.enabled && i == 10) {
        this.newBizParam.diyDayItemSum = {
          enabled: false,
          dayLimitMax: null,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "3",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "10",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "11",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "15",
              sumLimitMax: null,
            },
          ],
        };
      }

      //规则4
      if (!this.newBizParam.monthItemSameSum.enabled && i == 4) {
        this.newBizParam.monthItemSameSum = {
          enabled: false,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "3",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "10",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "11",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "15",
              sumLimitMax: null,
            },
          ],
        };
      }
      //规则5
      if (!this.newBizParam.dayCustomerSumAndSame.enabled && i == 5) {
        this.newBizParam.dayCustomerSumAndSame = {
          enabled: false,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "1",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "2",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "4",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "14",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: CustomerTypeEnum.all_customer_type,
              sameLimitMax: null,
              sumLimitMax: null,
            },
          ],
        };
      }
      //规则11
      if (!this.newBizParam.diyDayCustomerSumAndSame.enabled && i == 11) {
        this.newBizParam.diyDayCustomerSumAndSame = {
          enabled: false,
          isSamePerson: null,
          dayLimitMax: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "1",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "2",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "4",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "14",
              sameLimitMax: null,
              sumLimitMax: null,
            },
          ],
        };
      }

      //规则7
      if (!this.newBizParam.monthCustomerSameSum.enabled && i == 7) {
        this.newBizParam.monthCustomerSameSum = {
          enabled: false,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "1",
              sumLimitMax: null,
              isSamePersonExecute: null,
            },
            {
              enabled: false,
              customerType: "2",
              sumLimitMax: null,
              isSamePersonExecute: null,
            },
            {
              enabled: false,
              customerType: "4",
              sumLimitMax: null,
              isSamePersonExecute: null,
            },
            {
              enabled: false,
              customerType: "14",
              sumLimitMax: null,
              isSamePersonExecute: null,
            },
          ],
        };
      }
      //规则6
      if (!this.newBizParam.dayCustomerSameSum.enabled && i == 6) {
        this.newBizParam.dayCustomerSameSum = {
          enabled: false,
          isSamePerson: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "1",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "2",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "4",
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "14",
              sumLimitMax: null,
            },
          ],
        };
      }
      //规则12
      if (!this.newBizParam.diyDayCustomerSameSum.enabled && i == 12) {
        this.newBizParam.diyDayCustomerSameSum = {
          enabled: false,
          isSamePerson: null,
          dayLimitMax: null,
          ruleItemList: [
            {
              enabled: false,
              customerType: "1",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "2",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "4",
              sameLimitMax: null,
              sumLimitMax: null,
            },
            {
              enabled: false,
              customerType: "14",
              sameLimitMax: null,
              sumLimitMax: null,
            },
          ],
        };
      }
      // 规则13
      if (!this.newBizParam.checkIntervalTime.enabled && i == 13) {
        this.newBizParam.checkIntervalTime = {
          enabled: false,
          intervalTime: null,
        };
      }
      this.$forceUpdate();
    },
    checkResult() {
      this.isOpenCheck = true;
      this.$forceUpdate();
      let {
        selectItemNum,
        dayItemBelongSameCustomer,
        dayItemSum,
        diyDayCustomerSumAndSame,
        dayCustomerSumAndSame,
        monthItemSameSum,
        monthCustomerSameSum,
        dayCustomerSameSum,
        diyDayCustomerSameSum,
        diyDayItemBelongSameCustomer,
        diyDayItemSum,
        checkIntervalTime,
      } = this.newBizParam;
      //规则1 校验
      if (
        selectItemNum.enabled &&
        (!selectItemNum.limitMax ||
          !selectItemNum.ruleItemList ||
          !selectItemNum.ruleItemList.length)
      )
        return;
      //规则2 校验
      if (
        dayItemBelongSameCustomer.enabled &&
        !dayItemBelongSameCustomer.isSamePerson
      )
        return;
      try {
        let count = 0;
        dayItemBelongSameCustomer.ruleItemList.forEach((k) => {
          if (dayItemBelongSameCustomer.enabled && !k.enabled) {
            count++;
          }
          if (count == 3) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && (!k.sumLimitMax || !k.sameLimitMax)) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则9  校验
      if (
        diyDayItemBelongSameCustomer.enabled &&
        (!diyDayItemBelongSameCustomer.isSamePerson ||
          !diyDayItemBelongSameCustomer.dayLimitMax)
      )
        return;
      try {
        let count = 0;
        diyDayItemBelongSameCustomer.ruleItemList.forEach((k) => {
          if (diyDayItemBelongSameCustomer.enabled && !k.enabled) {
            count++;
          }
          if (count == 3) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && (!k.sumLimitMax || !k.sameLimitMax)) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则3 校验
      if (dayItemSum.enabled && !dayItemSum.isSamePerson) return;
      try {
        let count = 0;
        dayItemSum.ruleItemList.forEach((k) => {
          if (dayItemSum.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则10 校验
      if (
        diyDayItemSum.enabled &&
        (!diyDayItemSum.isSamePerson || !diyDayItemSum.dayLimitMax)
      )
        return;
      try {
        let count = 0;
        diyDayItemSum.ruleItemList.forEach((k) => {
          if (diyDayItemSum.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则4 校验
      if (monthItemSameSum.enabled && !monthItemSameSum.isSamePerson) return;
      try {
        let count = 0;
        monthItemSameSum.ruleItemList.forEach((k) => {
          if (monthItemSameSum.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则5 校验
      if (dayCustomerSumAndSame.enabled && !dayCustomerSumAndSame.isSamePerson)
        return;
      try {
        let count = 0;
        dayCustomerSumAndSame.ruleItemList.forEach((k) => {
          if (dayCustomerSumAndSame.enabled && !k.enabled) {
            count++;
          }
          if (count == dayCustomerSumAndSame.ruleItemList.length) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (
            k.enabled &&
            k.customerType != "99" &&
            (!k.sumLimitMax || !k.sameLimitMax)
          ) {
            throw new Error("");
          }
          if (k.enabled && k.customerType == "99" && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则11
      if (
        diyDayCustomerSumAndSame.enabled &&
        (!diyDayCustomerSumAndSame.isSamePerson ||
          !diyDayCustomerSumAndSame.dayLimitMax)
      )
        return;
      try {
        let count = 0;
        diyDayCustomerSumAndSame.ruleItemList.forEach((k) => {
          if (diyDayCustomerSumAndSame.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && (!k.sumLimitMax || !k.sameLimitMax)) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }

      //规则6 校验
      if (monthCustomerSameSum.enabled && !monthCustomerSameSum.isSamePerson)
        return;
      try {
        let count = 0;
        monthCustomerSameSum.ruleItemList.forEach((k) => {
          if (monthCustomerSameSum.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }

      if (dayCustomerSameSum.enabled && !dayCustomerSameSum.isSamePerson)
        return;
      try {
        let count = 0;
        dayCustomerSameSum.ruleItemList.forEach((k) => {
          if (dayCustomerSameSum.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      //规则12 校验
      if (
        diyDayCustomerSameSum.enabled &&
        (!diyDayCustomerSameSum.isSamePerson ||
          !diyDayCustomerSameSum.dayLimitMax)
      )
        return;
      try {
        let count = 0;
        diyDayCustomerSameSum.ruleItemList.forEach((k) => {
          if (diyDayCustomerSameSum.enabled && !k.enabled) {
            count++;
          }
          if (count == 4) {
            throw new Error("请至少勾选一个限制规则");
          }
          if (k.enabled && !k.sumLimitMax) {
            throw new Error("");
          }
        });
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      // 规则13 校验
      const visitStartTimeObj = this.fieldList?.find(item => item.fieldName === 'visitStartTime')
      if (visitStartTimeObj?.formVisible == 'Y' && !checkIntervalTime.enabled) {
        this.$message.error('配置了拜访开始时间，请必须配置规则13');
        return;
      }
      if (checkIntervalTime.enabled && !checkIntervalTime.intervalTime) {
        return;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.rule {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
}
.w260 {
  width: 260px;
}

.w130 {
  width: 140px;
}

.rule-input-box {
  width: 90px;
}
.txt {
  margin: 0 10px;
}
.theme-color {
  color: #4fa1a4;
  font-style: normal;
}
.tips-color {
  color: red;
  font-style: normal;
}
.rule-child {
  padding-left: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fafafa;
  margin-bottom: 10px;
  margin-left: 72px;
}
.tips {
  color: red;
  font-size: 12px;
}
.red-border {
  border: 1px solid red;
  border-radius: 4px;
}
.red-border /deep/ .el-input__inner {
  border: 0 none;
}
span {
  display: inline-block;
}
.rule-child .rule:last-child {
  margin-bottom: 0px;
}
.line {
  height: 1px;
  background: #d9d9d9;
  margin: 16px 0;
}
h5 {
  font-size: 14px;
  color: #212212;
  width: 140px;
  text-align: left;
  margin: 0;
  font-weight: normal;
}
.rule-wrap {
  display: flex;
}
/deep/ .el-tabs__active-bar {
  width: 72px !important;
}
</style>
